import { api } from '../utils/apiClient';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';
import type {
  GetTemplatesResponse,
  GetTemplateResponse,
  CreateTemplateRequest,
  PreviewTemplateRequest,
  PreviewTemplateResponse,
  TemplateType,
} from '../types/template';

const BASE_URL = API_BASE_URL.CAMPAIGN;

/**
 * Get all survey templates (SMS and Email)
 */
export const getAllTemplates = async (): Promise<GetTemplatesResponse> => {
  try {
    const response = await api.get<GetTemplatesResponse>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.GET_ALL}`
    );
    return response;
  } catch (error) {
    console.error('Error fetching all templates:', error);
    throw error;
  }
};

/**
 * Get SMS template
 */
export const getSmsTemplate = async (): Promise<GetTemplateResponse> => {
  try {
    const response = await api.get<GetTemplateResponse>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.GET_SMS}`
    );
    return response;
  } catch (error) {
    console.error('Error fetching SMS template:', error);
    throw error;
  }
};

/**
 * Get Email template
 */
export const getEmailTemplate = async (): Promise<GetTemplateResponse> => {
  try {
    const response = await api.get<GetTemplateResponse>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.GET_EMAIL}`
    );
    return response;
  } catch (error) {
    console.error('Error fetching Email template:', error);
    throw error;
  }
};

/**
 * Create or update a template (upsert)
 */
export const createOrUpdateTemplate = async (
  data: CreateTemplateRequest
): Promise<GetTemplateResponse> => {
  try {
    const response = await api.post<GetTemplateResponse>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.CREATE}`,
      data
    );
    return response;
  } catch (error) {
    console.error('Error creating/updating template:', error);
    throw error;
  }
};

/**
 * Preview a template with sample data
 */
export const previewTemplate = async (
  data: PreviewTemplateRequest
): Promise<PreviewTemplateResponse> => {
  try {
    const response = await api.post<PreviewTemplateResponse>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.PREVIEW}`,
      data
    );
    return response;
  } catch (error) {
    console.error('Error previewing template:', error);
    throw error;
  }
};

/**
 * Delete a template (revert to default)
 */
export const deleteTemplate = async (type: TemplateType): Promise<{ success: boolean }> => {
  try {
    const response = await api.delete<{ success: boolean }>(
      `${BASE_URL}${API_ENDPOINTS.TEMPLATE.DELETE}/${type}`
    );
    return response;
  } catch (error) {
    console.error('Error deleting template:', error);
    throw error;
  }
};

